<template>
  <BittsAlert
    v-if="alert"
    :message="alert.message"
    :description="alert.description"
    :color="alert.color"
    class="mb-24 pt-12"
  />
</template>

<script setup lang="ts">
import { BittsAlert } from '@crossbeam/bitts';

import { computed } from 'vue';

import useSlackChannelSearch from '@/composables/useSlackChannelSearch';

const { showSyncingState, hasNoSyncedChannels, hasSyncError } =
  useSlackChannelSearch();

const SYNC_ALERTS = {
  error: {
    color: 'error',
    message: "We couldn't refresh your Slack channels",
    description:
      'The list below may be out of date. We had trouble reaching Slack during the last sync.',
  },
  syncing: {
    color: 'info',
    message: 'Your Slack channels are being prepared',
    description:
      'Check back after the next sync to select a newly created channel.',
  },
  empty: {
    color: 'info',
    message: 'No Slack channels found',
    description: "We didn't find any Slack channels for your workspace.",
  },
} as const;

const alert = computed(() => {
  if (hasSyncError.value) return SYNC_ALERTS.error;
  if (showSyncingState.value) return SYNC_ALERTS.syncing;
  if (hasNoSyncedChannels.value) return SYNC_ALERTS.empty;
  return null;
});
</script>
